<template>
  <base-dialog
    :value="prompt.show"
    max-width="720px"
    persistent
    scrollable
    title="Nhập tọa độ cho file PDF thường"
    width="50%"
    @close="onCancel"
  >
    <base-form ref="form" lazy-validation @submit.stop="onSubmit">
      <div class="text-body-2 mb-4">
        Các file sau không có thông tin tọa độ. Vui lòng nhập hệ tọa độ và vùng
        bao trước khi tiếp tục tạo bộ dữ liệu.
      </div>
      <pdf-georef-fields
        v-for="file in prompt.files"
        :key="file.file_name"
        :file-name="file.file_name"
        :srs-list="srsList"
        :invalid="!isCompletePdfGeoref(georefs[file.file_name])"
        :value="georefs[file.file_name]"
        @input="setGeoref(file.file_name, $event)"
      />
    </base-form>
    <template v-slot:extra-btn>
      <v-btn class="text-none" color="primary" @click="onSubmit">
        Tiếp tục tạo bộ dữ liệu
      </v-btn>
    </template>
  </base-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { API_SRS } from '@api'
import PdfGeorefFields from './dialog-forms/pdf-georef-fields.vue'
import { emptyPdfGeoref, isCompletePdfGeoref } from '@utils/geo-pdf'

export default {
  components: { PdfGeorefFields },
  data: () => ({
    srsList: [],
    georefs: {},
  }),
  computed: {
    ...mapGetters({
      prompt: 'datastore/pdfGeorefPrompt',
    }),
  },
  watch: {
    'prompt.show'(show) {
      if (!show) return
      this.fetchSrsList()
      const next = {}
      ;(this.prompt.files || []).forEach((file) => {
        next[file.file_name] = Object.assign(
          {},
          emptyPdfGeoref(),
          this.prompt.prefill && this.prompt.prefill[file.file_name]
            ? this.prompt.prefill[file.file_name]
            : {},
          { is_geopdf: false }
        )
      })
      this.georefs = next
    },
  },
  methods: {
    setGeoref(name, value) {
      this.$set(this.georefs, name, value)
    },
    async fetchSrsList() {
      const res = await API_SRS.list()
      this.srsList = res.data || []
    },
    async onSubmit() {
      if (!(await this.$refs.form.validate())) return
      const files = this.prompt.files || []
      const incomplete = files.filter(
        (file) => !isCompletePdfGeoref(this.georefs[file.file_name])
      )
      if (incomplete.length) return
      this.$store.dispatch('datastore/resolvePdfGeoref', this.georefs)
    },
    onCancel() {
      this.$store.dispatch('datastore/cancelPdfGeoref')
    },
  },
}
</script>
